/* eslint-disable @typescript-eslint/no-explicit-any */
export type Method = "PUT" | "PATCH" | "DELETE" | "GET" | "POST";
type OnSuccess = (data: any) => void;
type OnError = (reason: any) => void;

export const get = (url: string, onSuccess: OnSuccess, onError: OnError) => {
  createRequest(url, "GET", null, onSuccess, onError);
};

export const post = (url: string, data: any, onSuccess: OnSuccess, onError: OnError) => {
  createRequest(url, "POST", data, onSuccess, onError);
};

export const put = (url: string, data: any, onSuccess: OnSuccess, onError: OnError) => {
  createRequest(url, "PUT", data, onSuccess, onError);
};

export const patch = (url: string, data: any, onSuccess: OnSuccess, onError: OnError) => {
  createRequest(url, "PATCH", data, onSuccess, onError);
};

export const getCSRFToken = () => {
  const metaTags = document.getElementsByName("csrf-token") as NodeListOf<HTMLMetaElement>;
  return metaTags[0].content;
};

const createRequest = (
  url: string,
  method: Method,
  data: any,
  onSuccess: OnSuccess,
  onError: OnError,
) => {
  const options: RequestInit = {
    method,
    headers: jsonHeaders(),
    cache: "no-cache",
    credentials: "same-origin",
  };

  if (data) options.body = JSON.stringify(data);

  fetch(url, options)
    .then(response => {
      if (response.status !== 200) {
        onError({ status: response.status, statusText: response.statusText });
      }

      return response.json();
    })
    .catch(error => {
      onError(error);
    })
    .then(json => {
      onSuccess(json);
    });
};

export const jsonHeaders = () => {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-Token": getCSRFToken(),
  });
};
